import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();


export const usePlanStore = defineStore("plan", {
    state: () => {
        return {
            datas: null,
            lists: [],
            selectedPlans: null,
            totals: 0,
            couponNames: null,
            coupons: null,
            loadings: false
        };
    },

    getters: {
        data: (state) => state.datas,
        list: (state) => state.lists,
        selectedPlan: (state) => state.selectedPlans,
        coupon: (state) => state.coupons,
        total: (state) => state.totals,
        couponName: (state) => state.couponNames,
        loading: (state) => state.loadings,
    },

    actions: {
        get() {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'plan',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.datas = res.data.data.plans
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        getCoupon(coupon) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'plan/copon',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    copon: coupon,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.coupons = res.data.data.percent
                        this.couponNames = coupon
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        history(page, limit) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'plan/history',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    page: page,
                    limit: limit
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.totals = res?.data?.data?.count
                        this.lists = res.data.data.history
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        choose(id, type, obj) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'plan/choose',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    planid: id,
                    type: type,
                    ...obj
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        upgrade(id, type, obj) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'plan/choose/upgrade',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    planid: id,
                    type: type,
                    ...obj
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        nextPhase(id) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'plan/nextphase',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        }
    },
});